import {RefinementListFilter} from 'searchkit';
import FacetAccessor from './FacetAccessor';

class CustomFacetFilter extends RefinementListFilter {
  defineAccessor() {
    return new FacetAccessor(
      this.props.field, this.getAccessorOptions()
    )
  }   
}

export default CustomFacetFilter;



// WEBPACK FOOTER //
// ./src/FacetFilter.js